import { Rocket, ShieldCheck } from 'lucide-react';

/**
 * Full-screen maintenance overlay. Rendered by App.js whenever
 * useAppConfig().maintenance_mode is true, so ALL routes are intercepted.
 */
export default function MaintenanceScreen() {
    return (
        <div
            data-testid="maintenance-screen"
            className="min-h-screen bg-[#0B0D10] text-white grid place-items-center px-6"
        >
            <div className="max-w-2xl w-full">
                <div className="flex items-center gap-3">
                    <div className="h-10 w-10 grid place-items-center bg-[#FF6B35]">
                        <Rocket className="h-5 w-5 text-white" strokeWidth={2.4} />
                    </div>
                    <p className="text-xs uppercase tracking-[0.32em] text-[#FF6B35]">System scaling</p>
                </div>
                <h1 className="mt-8 font-heading text-4xl sm:text-5xl font-medium tracking-tighter leading-[1.05]">
                    Scaling Pipelines In Progress <span aria-hidden>🚀</span>
                </h1>
                <p className="mt-6 text-base sm:text-lg text-slate-300 leading-relaxed">
                    Our founding engineering team is actively upgrading our database tracks to handle
                    a massive influx of creators. Your data is <strong className="text-white">100% safe</strong>.
                    We will be right back online shortly!
                </p>
                <p className="mt-6 text-slate-400">
                    Thank you for battle-testing the beta with us.
                </p>
                <div className="mt-10 flex items-center gap-3 border border-white/10 bg-white/[0.02] p-4 text-xs uppercase tracking-[0.2em] text-slate-400">
                    <ShieldCheck className="h-4 w-4 text-[#FF6B35]" />
                    Auto-recovery active · zero data loss guarantee
                </div>
            </div>
        </div>
    );
}
